import React, { useEffect } from "react";
import styles from "./style.module.css";
import sectionStyles from "../sectionStyles.module.css";
import Carousel from "../../components/carousel";
import { TEXTS } from "../../static/texts";
import { IMAGES } from "../../static/assets/images";

const bodegas = [
  {
    header: "Bodega Pedro Parra",
    subHeader: TEXTS.BODEGA_PEDRO_PARRA_SUBHEADER,
    description: TEXTS.BODEGA_PEDRO_PARRA_DESCRIPTION,
    slides: [
      IMAGES.SLIDE_PARRA_1,
      IMAGES.SLIDE_PARRA_2,
      IMAGES.SLIDE_PARRA_3,
      IMAGES.SLIDE_PARRA_4,
      IMAGES.SLIDE_PARRA_5,
      IMAGES.SLIDE_PARRA_7,
      IMAGES.SLIDE_PARRA_6,
      IMAGES.SLIDE_PARRA_8,
      IMAGES.SLIDE_PARRA_9,
      IMAGES.SLIDE_PARRA_10,
    ],
  },
  {
    header: "Bodega Roberto Henriquez",
    subHeader: TEXTS.BODEGA_ROBERTO_HENRIQUEZ_SUBHEADER,
    description: TEXTS.BODEGA_ROBERTO_HENRIQUEZ_DESCRIPTION,
    slides: [
      IMAGES.SLIDE_HENRIQUEZ_1,
      IMAGES.SLIDE_HENRIQUEZ_6,
      IMAGES.SLIDE_HENRIQUEZ_3,
      IMAGES.SLIDE_HENRIQUEZ_4,
      IMAGES.SLIDE_HENRIQUEZ_5,
      IMAGES.SLIDE_HENRIQUEZ_7,
      IMAGES.SLIDE_HENRIQUEZ_8,
      IMAGES.SLIDE_HENRIQUEZ_2,
      IMAGES.SLIDE_HENRIQUEZ_9,
    ],
  },
];

export const Bodegas = ({ pageTop }) => {
  useEffect(() => {
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [pageTop]);
  return (
    <>
      <div className={styles.bannerContainer}>
        <h1 className={sectionStyles.titleText}>
          {TEXTS.SERVICES_BODEGAS_TITLE}
        </h1>
      </div>
      <div className={sectionStyles.redContainer}>
        <p className={sectionStyles.flavorText}>
          {TEXTS.SERVICES_BODEGAS_FLAVOR}
        </p>
      </div>
      <div className={sectionStyles.blackContainer}>
        {bodegas.map((bodega, index) => (
          <>
            <Carousel key={index} carouselData={bodega} />
            {index < bodegas.length - 1 && (
              <div className={sectionStyles.separator} />
            )}
          </>
        ))}
      </div>
    </>
  );
};
